import React, { useState } from "react";
import ArrowDropDown from "../../../../../assets/responsiveIcons/ArrowDropDown";
import Eth from "../../../../../assets/icons/eth.svg";
import DropDown from "../../../../reusable/DropDown";
import ShadeBackgound from "../../../../reusable/ShadeBackgound";

function SelectNetwork({ networks = [], setNetwork ,type="normal" }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOnClick = (e) => {
    setNetwork(networks.find((element)=> element.name === e.target.name));
  };

  const findSelectedNetwork = (networks) => {
    try{
      for (let i = 0; i < networks.length; i++) {
        const element = networks[i];
        
        if (element.isSelectedAsTo) {
          return element;
        } else{
        }
      }
      return null;
    }catch(e){
      // console.log(e)
    }
   
  };

  return (
    <div>
      <div className="my-1 flex relative " onClick={() => setIsOpen(!isOpen)}>
        {/* <img className="mr-3" src={Eth} alt="Eth" /> */}
        <div className="mr-3">{findSelectedNetwork(networks)?.icon}</div>
        <div className="flex  justify-between items-center">
          <p className={type === 'tocken' ? 'font-normal' : "font-medium"}>{findSelectedNetwork(networks)?.label}</p>
          <div className="ml-4">
            <ArrowDropDown />
          </div>
        </div>
        <DropDown
          top={3.1}
          left={-0.81}
          selected={findSelectedNetwork(networks)?.name}
          items={networks}
          isOpen={isOpen}
          onClick={handleOnClick}
          className="dark:!bg-dark-secondary !bg-sunny-primary"
        />
      </div>
      {isOpen && (
        <ShadeBackgound
          opacity={0.2}
          onClik={() => isOpen && setIsOpen(false)}
        />
      )}
    </div>
  );
}

export default SelectNetwork;
